import { useTranslation } from 'react-i18next';

import { InfoModal } from './InfoModal';
import { useSessionNoticeStore } from './session-notice.store';

/**
 * Renders the acknowledged notice for an involuntarily ended session (SHCT-622). Mounted at the app
 * root next to the toast container so it outlives the redirect that follows.
 *
 * SHCT-861 — [확인] is what triggers the sign-out and the jump to /login (PRD 00 §8.3 `얼럿 후 초기화`).
 * The interceptor hands that teardown to the store; acknowledging runs it.
 *
 * `dismissible={false}` because [확인] must be the ONLY way out (QC re-report). The earlier build
 * routed Esc and the backdrop through the same `acknowledge`, which kept the session from ever
 * being half-torn-down but meant a stray click outside the alert signed the user out — indis-
 * tinguishable, to them, from the redirect-without-[확인] this ticket was raised to stop. Blocking
 * the two casual exits keeps the same guarantee by the opposite route: the modal simply stays up,
 * so there is no path that dismisses the notice while leaving the evicted session in place.
 */
export function SessionNoticeHost() {
  const { t } = useTranslation('auth');
  const kind = useSessionNoticeStore((s) => s.kind);
  const acknowledge = useSessionNoticeStore((s) => s.acknowledge);

  return (
    <InfoModal
      open={kind === 'SUPERSEDED'}
      title={t('login.duplicateSessionModal.title')}
      body={t('login.errors.duplicateSession')}
      confirmLabel={t('login.duplicateSessionModal.confirm')}
      dismissible={false}
      onClose={acknowledge}
    />
  );
}
